import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=5ffcec31&scoped=true"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"
import style0 from "./ReturnPolicy.vue?vue&type=style&index=0&id=5ffcec31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcec31",
  null
  
)

export default component.exports